import React from 'react';
import {FormInput} from 'react-form';
import DatePicker from 'react-datetime';
import moment from 'moment';

export default ( { append, dateFormat, field, prefix, suffix, clearable, ...rest } ) => {

  return (
    <FormInput field={field}>
      {( { setValue, getValue, setTouched } ) =>
        append ?
          <div className="input-group" id={field}>
            {prefix ? <span className="input-group-addon" dangerouslySetInnerHTML={{ __html: prefix }}/> : null }
            <DatePicker
              {...rest}
              value={getValue() ? moment( getValue() ).format( dateFormat || 'DD/MM/YYYY' ) : ''}
              onChange={setValue}
              onBlur={setTouched}
              timeFormat={false}
              dateFormat={dateFormat ? dateFormat : 'DD/MM/YYYY'}
              closeOnSelect={true}
            />
            {clearable ? <span className="input-group-addon" onClick={setValue( null )}
                            dangerouslySetInnerHTML={{ __html: suffix }}/> : null }
            {suffix ? <span className="input-group-addon"
                            dangerouslySetInnerHTML={{ __html: suffix }}/> : null }
          </div> :
          <div className="input-group">
            <DatePicker
              {...rest}
              value={getValue() ? moment( getValue() ).format( dateFormat || 'DD/MM/YYYY' ) : ''}
              onChange={setValue}
              onBlur={setTouched}
              timeFormat={false}
              dateFormat={dateFormat ? dateFormat : 'DD/MM/YYYY'}
              closeOnSelect={true}
            />
            {clearable && getValue() ? <span className="input-group-addon fa fa-times pointer"
                                             onClick={() => setValue( null )}/> : null }
          </div>
      }
    </FormInput>
  )
}



// WEBPACK FOOTER //
// ./components/FormElements/DatePicker/index.js